import { toast } from "react-toastify";
import api from "../api/apiClient";

const topicService = {
  searchTopics: async (userId, topicNames) => {
    try {
      const response = await api.post(`/topicName/search/${userId}/`, {
        topicNames: topicNames,
      });
      if (response.data.nodes.length === 0) {
        // Show toast message if nodes array is empty
        toast.error("No results found");
      }
      return response.data;
    } catch (error) {
      toast.error("Error in searchTopics:", error);
      throw error;
    }
  },
};

export default topicService;
